import { useTranslation } from "react-i18next"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useMessage } from "../../context/useMessageContext"
import { PostRequest } from "../../services/ApiClientService"
import { useGetTables } from "./useGetTables"

interface TableSelfServiceActivationCode {
  activationCode: string
  expiresAtUtc?: string
}

export const useTableSelfService = () => {
  const { t } = useTranslation("general")
  const { setError } = useError()
  const { setMessage } = useMessage()
  const { handleGetTable } = useGetTables()

  const handleCreateActivationCode = async (
    tableId: number,
    onSuccess: (activation: TableSelfServiceActivationCode) => void,
  ) => {
    try {
      const response = await PostRequest<TableSelfServiceActivationCode>(
        API_ROUTES.TABLE.CREATE_SELF_SERVICE_ACTIVATION_CODE(tableId),
        {},
      )

      if (!response.success || !response.data) {
        throw new Error(response.message)
      }

      onSuccess(response.data)
      return true
    } catch (error) {
      setError(
        t("label_title_erro"),
        error instanceof Error ? error.message : t("label_unknown_error_description"),
      )
      return false
    }
  }

  const handleRevokeTablet = async (tableId: number, onSuccess: () => void) => {
    try {
      const response = await PostRequest(API_ROUTES.TABLE.REVOKE_SELF_SERVICE(tableId), {})

      if (!response.success) {
        throw new Error(response.message)
      }

      await handleGetTable(() => {})
      setMessage(t("tableSelfService:title"), t("tableSelfService:revoked"))
      onSuccess()
      return true
    } catch (error) {
      setError(
        t("label_title_erro"),
        error instanceof Error ? error.message : t("label_unknown_error_description"),
      )
      return false
    }
  }

  return {
    handleCreateActivationCode,
    handleRevokeTablet,
  }
}

